import { createApiRef } from '@backstage/core-plugin-api';
import { CreateApplicationPipeline } from './dto/request/create-application-deploy.request';
import { CreateApplicationDeployRoot } from './dto/response/create-application-deploy.response';
import { GetJobLog } from './dto/response/get-job-log.response';
import { GetApplicationDeployRoot } from './dto/response/get-application-deploy.response';

export interface ApplicationDeployApi {
    getApplicationDeploy: (environment: string, system_name: string, application_name: string) => Promise<GetApplicationDeployRoot>;
    createApplicationDeploy: (environment: string, system_name: string, body: CreateApplicationPipeline) => Promise<CreateApplicationDeployRoot>;
    getJobLog: (environment: string, system_name: string, application_name: string, job_id: number) => Promise<GetJobLog>;
}

export const ApplicationDeployApiRef = createApiRef<ApplicationDeployApi>({
    id: 'plugin.application-deploy-api.service'
})